import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, CircularProgress, Grid } from '@mui/material';
import ProfileProviderCard from './ProfileProviderCard';
import { getTopProviders } from '../../../actions/profile';

const ProfileProvidersList = ({ currentUserId }) => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const topProviders = await getTopProviders();
        // Filtrar el proveedor actual
        const filtered = topProviders.filter(p => p.user !== currentUserId);
        setProviders(filtered);
      } catch (error) {
        console.error("Failed to fetch top providers:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProviders();
  }, []);

  if (loading) {
    return (
      <Grid container justifyContent="center" sx={{ my: 6 }}>
        <CircularProgress />
      </Grid>
    );
  }

  // If no providers are returned, we simply don't render the section.
  if (providers.length === 0) return null;

  return (
    <Box sx={{ mt: 8 }}>
      <Grid container justifyContent="space-between" alignItems="flex-end" sx={{ mb: 4 }}>
        <Box>
          <Typography variant="h5" fontWeight="bold" color="primary" sx={{ mb: 0.5 }}>
            Perfiles de proveedores
          </Typography>
          <Typography variant="body2" color="#737791">
            que creemos podrían interesarte
          </Typography>
        </Box>
        {/* <Typography
            variant="body2"
            color='primary'
            sx={{
              fontWeight: 'bold',
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Mostrar los {providers.reduce((acc, p) => acc + p.serviceCount, 0)} servicios
          </Typography> */}
      </Grid>

      <Grid container
        wrap="nowrap"
        spacing={3}
        sx={{
          overflowX: 'auto',
          pb: 2,
          '&::-webkit-scrollbar': { height: 8 },
          '&::-webkit-scrollbar-thumb': { bgcolor: '#E0E0E0', borderRadius: 4 },
          scrollBehavior: 'smooth'
        }}
      >
        {providers.map((profile, index) => (
          <Grid item="true" key={profile.user || index}>
            <ProfileProviderCard profile={profile} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProfileProvidersList;
